import React from 'react'
import { RouteComponentProps } from 'react-router'
import { bewizrMeetingsStore } from '~/stores'
import { observer } from '~/ui/component'
import { EmptyOrFetching, Scroller } from '~/ui/components'
import { AppLayoutConfig } from '~/ui/layouts'
import BeWizrMeetingView from './BeWizrMeetingView'

export interface BeWizrMeetingParams {
  id:           string
  occurrenceID?: string
}

export type Props = RouteComponentProps<BeWizrMeetingParams>

const BeWizrMeetingScreen = observer('BeWizrMeetingScreen', (props: Props) => {

  const {id, occurrenceID} = props.match.params

  const document    = bewizrMeetingsStore.meetings.document(id)
  const meeting     = document.data
  const fetchStatus = document.fetchStatus

  const occurrence = React.useMemo(() => {
    if (occurrenceID != null) {
      return document.resolveOccurrence(occurrenceID)
    } else if (meeting?.occurrences.length === 1) {
      return meeting?.occurrences[0]
    }
  }, [document, meeting, occurrenceID])

  // The API only returns upcoming occurrences. Links from learning tracks may still point to a
  // past occurrence, in which case we show the meeting itself instead of a 404.
  const occurrenceUnavailable = occurrenceID != null && occurrence == null

  React.useEffect(() => {
    document?.fetch()
  }, [document])

  //------
  // Rendering

  function render() {
    return (
      <>
        <AppLayoutConfig
          title={meeting?.title}
          fetchStatus={fetchStatus}
        />
        {renderContent()}
      </>
    )
  }

  function renderContent() {
    if (meeting == null || fetchStatus !== 'done') {
      return renderEmpty()
    }

    return (
      <Scroller>
        <BeWizrMeetingView
          meeting={meeting}
          occurrence={occurrence}
          occurrenceUnavailable={occurrenceUnavailable}
        />
      </Scroller>
    )
  }

  function renderEmpty() {
    return (
      <EmptyOrFetching
        flex
        status={fetchStatus}
      />
    )
  }

  return render()

})

export default BeWizrMeetingScreen